import React, { useState, useEffect, FC } from 'react';
import classes from './FilterPanel.module.scss';
import CustomisedCheckbox from '../../../components/CustomisedCheckbox';
import { Grid, GridCol } from '@mantine/core';

interface FilterTitle {
  [key: string]: {
    title: string;
    color: string;
  };
}

const filterTitle: FilterTitle = {
  permitSubmitted: {
    title: 'Applied For Permit',
    color: '#c85e19',
  },
  permitApproved: {
    title: 'Permit Approved',
    color: '#1a9798',
  },
};


interface StyleControlsProps {
  onChange: (visibilityChange: any) => void;
}

const StyleControls: FC<StyleControlsProps> = ({ onChange }) => {
  const [visibility, setVisibility] = useState<Record<string, boolean>>({
    permitSubmitted: true,
    // underAssessment: true,
    permitApproved: true,
    permitIssued: true,
  });

  useEffect(() => {
    // Convert true/false to "visible"/"none"
    const visibilityState = Object.fromEntries(
      Object.entries(visibility).map(([k, v]) => [k, v ? 'visible' : 'none'])
    );
    onChange(visibilityState);
  }, [visibility, onChange]);

  const onVisibilityChange = (name: any, value: any) => {
    setVisibility({ ...visibility, [name]: value });
  };

  return (
  <Grid className={classes.filterPanel}>
    {Object.keys(filterTitle).map((name) => (
      <GridCol span={6} key={name}>
        <CustomisedCheckbox
          name={name}
          title={filterTitle[name].title}
          isChecked={visibility[name]}
          colourTheme={filterTitle[name].color}
          onCheckboxChange={onVisibilityChange}
        />
      </GridCol>
    ))}
  </Grid>
  );
};

export default React.memo(StyleControls);
